"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartNumpad = useSmartNumpad;
/**
 * react-smart-numpad
 * MIT License © 2025 Christian Giangreco
 */
const react_1 = require("react");
const handleSmartNumpad_1 = require("./handleSmartNumpad");
function useSmartNumpad(initialValue = '', options = {}) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const onKeyDown = (event) => (0, handleSmartNumpad_1.handleSmartNumpadKeyDown)(event, setValue, options);
    const onChange = (e) => setValue(e.target.value);
    return { value, onChange, onKeyDown, setValue };
}
